<template>
  <div
    class="w-[100vw] h-[100vh] fixed top-0 left-0 flex justify-center items-center"
  >
    <div
      class="w-[40vw] max-h-[80vh] overflow-y-auto text-[var(--text)] gap-4 p-4 bg-[var(--fundoApp)] rounded-[10px] flex flex-col scrollbar-thin scrollbar-tema"
    >
      <div class="w-full flex gap-2 justify-between items-center">
        <h3 class="text-[#ff9b05]">Filtro de Periodicidades</h3>
        <AppButton
          class="text-[var(--text)]"
          :visibility="true"
          left_icon="fa-regular fa-circle-xmark fa-xl"
          emitType="close"
          @close="close"
          :width="23"
          :height="23"
        />
      </div>

      <!-- Dynamic Fields Selection (multiple selection enabled) -->
      <!-- <div class="flex gap-2 items-center">
        <label class="min-w-[6.5rem]">Campos:</label>
        <div class="flex flex-col w-full">
          <select
            v-model="selectedFields"
            multiple
            class="text-black text-[16px] border-1 border-[#ccc] p-1 rounded-[5px] w-[85%]"
          >
            <option
              v-for="field in availableFields"
              :key="field"
              :value="field"
              :disabled="defaultFields.includes(field)"
            >
              {{ field }}
            </option>
          </select>

          <div class="mt-2 flex flex-wrap gap-2 w-[85%]" >
            <span
              v-for="field in selectedFields"
              :key="field"
              class="bg-[#ccc] text-black px-2 py-1 rounded flex items-center"
            >
              {{ field }}
              <button
                @click="removeSelectedField(field)"
                class="ml-1 text-red-500"
              >
                <i class="fa-regular fa-circle-xmark"></i>
              </button>
            </span>
          </div>
        </div>
      </div> -->

     
      <!-- Tempo (Periodicidade) -->
      <div class="flex gap-2 items-center">
        <label class="min-w-[6.5rem]">Periodicidade (dias):</label>
        <div class="flex items-center justify-between w-full">
          <input
            type="number"
            v-model="tempo"
            min="1"
            class="text-black text-[16px] border-1 border-[#ccc] p-1 rounded-[5px] w-[85%]"
          />
          <button :style="{ color: 'red' }" @click="remove('tempo')">
            <i class="fa-regular fa-circle-xmark text-2xl"></i>
          </button>
        </div>
      </div>

      <!-- FAMILIA -->
      <div class="flex gap-2 items-center">
        <label class="min-w-[6.5rem]">Familia:</label>
        <input
          :disabled="true"
          type="text"
          v-model="familiaDisplay"
          class="text-black text-[16px] border-1 border-[#ccc] p-1 rounded-[5px] w-full"
        />
        <button
          class="fa-solid fa-pen-to-square text-2xl"
          :style="{ color: '#ff9b05' }"
          @click="open_dialog_alert('familia')"
        ></button>
        <button :style="{ color: 'red' }" @click="remove('familia')">
          <i class="fa-regular fa-circle-xmark text-2xl"></i>
        </button>
      </div>

      <!-- Serviço A -->
      <div class="flex gap-2 items-center">
        <label class="min-w-[6.5rem]">Serviço A:</label>
        <input
          :disabled="true"
          type="text"
          v-model="servicoADisplay"
          class="text-black text-[16px] border-1 border-[#ccc] p-1 rounded-[5px] w-full"
        />
        <button
          class="fa-solid fa-pen-to-square text-2xl"
          :style="{ color: '#ff9b05' }"
          @click="open_dialog_alert('servico_a')"
        ></button>
        <button :style="{ color: 'red' }" @click="remove('servico_a')">
          <i class="fa-regular fa-circle-xmark text-2xl"></i>
        </button>
      </div>

      <!-- Serviço B (Próximo) -->
      <div class="flex gap-2 items-center">
        <label class="min-w-[6.5rem]">Serviço B:</label>
        <input
          :disabled="true"
          type="text"
          v-model="servicoBDisplay"
          class="text-black text-[16px] border-1 border-[#ccc] p-1 rounded-[5px] w-full"
        />
        <button
          class="fa-solid fa-pen-to-square text-2xl"
          :style="{ color: '#ff9b05' }"
          @click="open_dialog_alert('servico_b')"
        ></button>
        <button :style="{ color: 'red' }" @click="remove('servico_b')">
          <i class="fa-regular fa-circle-xmark text-2xl"></i>
        </button>
      </div>


      <!-- Action Buttons -->
      <div class="flex gap-4 mt-4">
        <AppButton
          :padding="'var(--padding_btn)'"
          class="capitalize mb-auto"
          :visibility="true"
          :font_size="12"
          color="#ff9b05"
          left_icon="fa-solid fa-pen-to-square"
          text="Confirmar"
          emitType="select"
          @select="salvar_filtro"
        />

        <AppButton
          :padding="'var(--padding_btn)'"
          class="capitalize mb-auto"
          :visibility="true"
          :font_size="12"
          color="red"
          left_icon="fa-regular fa-rectangle-xmark"
          text="Cancelar"
          emitType="select"
          @select="close"
        />
      </div>
    </div>

    <!-- Dialog or StaticMultiTable for some fields -->
    <Dialog
      v-if="showDialog"
      :propsData="dialogProps"
      @close="closeDialog"
      @returnData="handleReturnData"
      :pagination="true"
      />
      <!-- :multiSelectOptions="{ enabled: true, show_btn: false }" -->

    <StaticMultiTable
      v-if="showStaticTable"
      :title="staticTable_title"
      :data="StaticTableData"
      @returnData="handleReturnData"
      @close="showStaticTable = false"
    />
  </div>
</template>

<script>
import { toRaw } from "vue";
import AppButton from "@/components/updated/button.vue";
import Dialog from "@/components/dialog/dinamicDialog.vue";
import StaticMultiTable from "@/components/tables/multiSelectTable.vue";

export default {
  name: "PeriodicidadeFilter",
  components: {
    AppButton,
    Dialog,
    StaticMultiTable,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // Basic filter fields
      tempo: "",
      // Dynamic fields selection for periodicidade
      availableFields: [
        "id",
        "familia",
        "servico_a",
        "servico_b",
        "tempo",
      ],
      selectedFields: [],
      // Default fields that must always be selected
      defaultFields: ["id", "nome", "familia"],
      // Pre-populate selectedFields with the default ones
      selectedFields: ["id", "familia", "servico_a", "servico_b", "tempo"],
      // Raw data arrays for selections
      rawFamilia: [],
      rawServicoA: [],
      rawServicoB: [],
      // Modal and dialog controls
      showDialog: false,
      showStaticTable: false,
      staticTable_title: "",
      StaticTableData: [],
      currentType: "",
      dialogProps: {
        entity: ["familia", "tpservico"],
        sideBar: false,
        multi: true,
        queryParams: {},
      },
    };
  },
  computed: {
    familiaDisplay() {
      return Array.isArray(this.rawFamilia) ? this.rawFamilia.map((item) => item.nome).join(", ") : "";
    },
    servicoADisplay() {
      return Array.isArray(this.rawServicoA) ? this.rawServicoA.map((item) => item.nome).join(", ") : "";
    },
    servicoBDisplay() {
      return Array.isArray(this.rawServicoB) ? this.rawServicoB.map((item) => item.nome).join(", ") : "";
    },
  },
  methods: {
    removeSelectedField(field) {
      // Do not allow removal of default fields.
      if (this.defaultFields.includes(field)) {
        return;
      }
      this.selectedFields = this.selectedFields.filter((f) => f !== field);
    },
    close() {
      this.$emit("close");
    },
    salvar_filtro() {
      const dataToSend = {
        tempo: this.tempo || "",
        familia: this.rawFamilia,
        servico_a: this.rawServicoA,
        servico_b: this.rawServicoB,
        // Send the selected dynamic fields as a comma-separated list
        fields: this.selectedFields.length ? this.selectedFields.join(",") : "",
      };
      this.$emit("save", dataToSend);
    },
    retirar_filtro() {
      this.$emit("save", {}); // Emit empty data to disable filter
    },
    open_dialog_alert(key) {
      if (key === "familia") {
        this.currentType = "familia";
        this.dialogProps.entity = ["familia"];
        this.dialogProps.title = "Famílias Existentes";
        this.dialogProps.sideBar = false;
        this.dialogProps.multi = true;
        this.showDialog = true;
      } else if (key === "servico_a") {
        this.currentType = "servico_a";
        this.dialogProps.entity = ["tpservico"];
        this.dialogProps.title = "Serviços A";
        this.dialogProps.sideBar = false;
        this.dialogProps.multi = true;
        this.showDialog = true;
      } else if (key === "servico_b") {
        this.currentType = "servico_b";
        this.dialogProps.entity = ["tpservico"];
        this.dialogProps.title = "Serviços B";
        this.dialogProps.sideBar = false;
        this.dialogProps.multi = true;
        this.showDialog = true;
      }
    },
    remove(key) {
      switch (key) {
        case "familia":
          this.rawFamilia = [];
          break;
        case "servico_a":
          this.rawServicoA = [];
          break;
        case "servico_b":
          this.rawServicoB = [];
          break;
        case "tempo":
          this.tempo = "";
          break;
        case "fields":
          this.selectedFields = [];
          break;
        default:
          break;
      }
    },
    normalizeKey(key) {
      return key.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },
    updateField(rawFieldKey, dataKey, payload) {
      let newValues = [];
      if (Array.isArray(payload)) {
        payload.forEach((item) => {
          if (item[dataKey]) {
            const value = item[dataKey];
            if (Array.isArray(value)) {
              newValues.push(...value);
            } else {
              newValues.push(value);
            }
          }
        });
      } else if (payload && typeof payload === "object") {
        const rawPayload = toRaw(payload);
        const keys = Object.keys(rawPayload);
        console.log("Available keys in payload (raw):", keys);
        const normalizedExpected = this.normalizeKey(dataKey.toLowerCase());
        const normalizedExpectedPlural = this.normalizeKey(
          dataKey.toLowerCase() + "s"
        );
        const matchedKey = keys.find((key) => {
          const normalizedKey = this.normalizeKey(key.toLowerCase());
          return (
            normalizedKey === normalizedExpected ||
            normalizedKey === normalizedExpectedPlural
          );
        });
        console.log("Matched key:", matchedKey);
        if (matchedKey) {
          const value = rawPayload[matchedKey];
          if (Array.isArray(value)) {
            value.forEach((item) => {
              if (Array.isArray(item)) {
                newValues.push(...item);
              } else {
                newValues.push(item);
              }
            });
          } else {
            newValues.push(value);
          }
        } else {
          console.warn(`No matching key for "${dataKey}" found in payload.`);
        }
      }
      // Ensure the field is initialized as an array
      if (!Array.isArray(this[rawFieldKey])) {
        this[rawFieldKey] = [];
      }

      newValues.forEach((val) => {
        if (!this[rawFieldKey].find((existing) => existing.id === val.id)) {
          this[rawFieldKey].push(val);
          console.log(`Added ${JSON.stringify(val)} to ${rawFieldKey}`);
        }
      });
      console.log(`${rawFieldKey} after update:`, this[rawFieldKey]);
    },
    handleReturnData(data) {
      console.log("Returned data:", data);
      switch (this.currentType) {
        case "familia":
          this.updateField("rawFamilia", "familia", data);
          break;
        case "servico_a":
          this.updateField("rawServicoA", "tpservico", data);
          break;
        case "servico_b":
          this.updateField("rawServicoB", "tpservico", data);
          break;
        default:
          break;
      }
      this.showDialog = false;
      this.showStaticTable = false;
    },
    closeDialog() {
      this.showDialog = false;
    },
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.tempo = val.tempo || "";
          this.rawFamilia = val.familia || [];
          this.rawServicoA = val.servico_a || [];
          this.rawServicoB = val.servico_b || [];
        }
      },
    },
  },
};
</script>

<style scoped>
.scrollbar-tema {
  scrollbar-width: thin;
  scrollbar-color: var(--scroll) transparent;
}
</style>